import themeGet from '@styled-system/theme-get';
import styled from 'styled-components';
import i18n from '../../../../../app/i18n';
import Text from '../../../../Text';

const AddAnswer = ({ onClick }) => {
  return (
    <Wrapper>
      <AddAnswerButton variant="small1" onClick={onClick}>
        <AddAnswerButtonIcon className="fa-solid fa-plus mr-1" />
        {i18n.t('tileForm:interaction.placeholders.addAnswer')}
      </AddAnswerButton>
    </Wrapper>
  );
};

export default AddAnswer;

const AddAnswerButtonIcon = styled.i`
  margin-right: 5px;
`;

const Wrapper = styled.div`
  display: flex;
`;

const AddAnswerButton = styled(Text)`
  cursor: pointer;
  border: none;
  background: transparent;
  color: ${themeGet('colors.primary.100')};
  margin-top: 6px;
  font-weight: 600;
  padding: 0;
  line-height: 18px;

  &:hover,
  :focus {
    background: transparent;
    color: ${themeGet('colors.primary.80')};
    outline: none;
  }
  &:active {
    box-shadow: none;
  }
`;
